<aside class="replace-relative-action big-input-grid-with">
  <h4 class="to"><span>with</span></h4>
  <div id="replace-relative-container">
    <mat-radio-group [formControl]="nowControl">
      <mat-radio-button class="today" value="now" [ngClass]="nowControl.value === 'now' ? '' : 'disabled'">
        <span class="description">Today</span>
      </mat-radio-button>
      <mat-radio-button class="chosen-date" value="dynamic" [ngClass]="nowControl.value === 'now' ? 'disabled' : ''"
                        [matTooltip]="nowControl.value === 'now' ? 'Set a dynamic date from now' : ''">
        <input type="number" min="1" oninput="validity.valid||(value='');" [formControl]="amountControl" [disabled]="nowControl.value === 'now'" required>
        <mat-select [formControl]="postFixControl" [disabled]="nowControl.value === 'now'" required>
          <mat-option *ngFor="let postFix of relativePostFixes" [value]="postFix.value">
            {{postFix.viewValue}}
          </mat-option>
        </mat-select>
        <span class="description">from now</span>
      </mat-radio-button>
    </mat-radio-group>
  </div>
<!--  {{formGroup.value | json}} | valid={{formGroup.valid}}, dirty={{formGroup.dirty}}-->
</aside>
